import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-music-note",
  "use": "icon-music-note-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" id=\"icon-music-note\">\r\n  <path d=\"M9 18V5l12-2v13\" />\r\n  <circle cx=\"6\" cy=\"18\" r=\"3\" />\r\n  <circle cx=\"18\" cy=\"16\" r=\"3\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol